import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "image-preview" };
const _hoisted_2 = {
    key: 0,
    class: "watermark"
};
const _hoisted_3 = { class: "calendar-preview mx-auto p-2" };
import '@fullcalendar/core/vdom'; // solves problem with Vite
import FullCalendar from '@fullcalendar/vue3';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
import { useCalendarImagesStore } from '../stores/calendarImages';
import { useCalendarTemplatesStore } from '../stores/calendarTemplates';
import { useInitStore } from '../stores/init';
import QuoteComponent from '../components/QuoteComponent.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'QuotesTemplate',
    setup(__props) {
        _useCssVars(_ctx => ({
            "0477244e": (_unref(calendarSettingsStore).title.color)
        }));
        const calendarSettingsStore = useCalendarSettingsStore();
        const calendarTemplatesStore = useCalendarTemplatesStore();
        const calendarImagesStore = useCalendarImagesStore();
        const initStore = useInitStore();
        calendarSettingsStore.title.fontFace.fontName = 'Rubik Bubbles';
        calendarSettingsStore.title.fontSize = 48;
        calendarSettingsStore.title.color = 'hsl(201 100% 78.58% / 1)';
        calendarSettingsStore.title.shadowColor = 'hsl(0 0% 0% / 0.35)';
        calendarSettingsStore.setDayNames('narrow');
        calendarSettingsStore.calendarOptions.titleFormat = { year: undefined, month: 'long' };
        calendarTemplatesStore.templateIndex = 3;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(QuoteComponent, { imageIndex: 0 }),
                    (_unref(calendarImagesStore).imageSelected)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "CustomCalendarMaker.com"))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(FullCalendar), {
                        ref: "fullcalendar",
                        options: _unref(calendarSettingsStore).calendarOptions
                    }, null, 8, ["options"])
                ])
            ], 64));
        };
    }
});
